import styled from 'styled-components'

export const StyledAdvanceCard = styled.div`
   
`;
export const StyledContainer=styled.div`
    width: 97%;
    height: 100%;
    padding: 1rem;
    padding-left: 3rem;
    background-color: white;
    
    border-radius: 1rem;
    margin-top: 1rem;
    @media(max-width: 768px){
        width: 80%;
        padding-left: 0.5rem;

    }
`;
export const style=styled.div`


`;
export const StyledHead=styled.div`
    display: flex;
    justify-content: space-between;
    p{
        font-size: 0.9rem;
    }
    button{
        background-color: #169395;
        color: white;
        padding: 0.2rem;
        border-radius: 0.3rem;
        margin-right: 1.5rem;
    }

`;
export const StyledInside=styled.div`
    background-color: white;
    color: black;

    margin: 3% auto;
    padding: 1rem;
    border-radius: 0.3rem;
    /* text-align: center; */
    h3{
        padding: 1rem;
        border-bottom: 2px solid black;
    }
    h4{
        color: #169395;
    }
    input{
        width: 100%;
        padding-top:0.5rem;
        padding-bottom:10rem;
        border: 1px solid #169395;
        border-radius: 0.5rem;
        margin-bottom:0;
    }
`;
export const StyledTwo=styled.div`
    display: flex;
    justify-content: space-between;
    h4{
        color: #169395;
    }
`;
export const StyledButton=styled.div`
    display: flex;
    gap: 1rem;
    margin-left: 75%;
    button{
        padding: 0.8rem;
        background-color: #169395;
        color: white;
        border-radius: 0.2rem;
        border: none;
        margin-top: 1rem;
    }
`
export const StyledShowandSearchContainer = styled.div`
    
    /* padding:1rem; */
    display:flex;
    justify-content:space-between;
    margin-top: 2rem;
    
`;
export const StyledInput = styled.div`
    display: flex;
   
    justify-content: space-around;
    gap: 1rem;
    input{
        border: 1px solid #169395;
        padding: 0.5rem;
        
        border-radius: 0.3rem;
    }
`;


export const StyledShow = styled.div`
    display:flex;
    width:25%;
    gap:0.5rem;
    align-items:center;
    @media(max-width: 768px){
        width: 40%;
        display: flex;
        gap: 1rem;
    }
`

export const StyledSearch = styled.div`
    display:flex;
    margin-right:2rem;
    align-items:center;
    gap: 0.5rem;
    border-radius: 0.3rem;
    @media(max-width: 768px){
        margin-right: 0.5rem;

    }

    input{
        width:100%;
        height:1.7rem;
    }

    
`;
export const StyledDesc = styled.div`
    display: flex;
    justify-content: space-between;
    
`;
export const StyledLast = styled.div`
    display: flex;
    gap: 3rem;
    p:hover{
        padding: 0.3rem;
        background-color: #169395;
        color: white;
        cursor: not-allowed;
        border-radius: 0.2rem;
    }
`;
export const Container = styled.div`

`;

export const StyledButtons = styled.div`
display:flex;
gap:0.5rem;
   margin-left:70%;
   margin-bottom:1rem;
   margin-top:0;
   
`;
